module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ge-svg-hover"
  }, [(!_vm.isIE) ? _c('svg', {
    class: ['ge-svg-hover', {
      state: _vm.state
    }],
    attrs: {
      "viewBox": _vm.viewBox
    }
  }, [_c('path')]) : _c('sky-svg', {
    staticClass: "fallback",
    attrs: {
      "name": _vm.from
    }
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6713ge/master/~/vue-loader/lib/template-compiler?{"id":"data-v-435770a8"}!F:/Solutions/6713ge/master/~/vue-loader/lib/selector.js?type=template&index=0!./scripts/ge-svg-hover/ge-svg-hover.vue
// module id = 350
// module chunks = 1